import { FMPolicyDialog } from "@fokused-me/web-ui";
import { usePolicy } from "../state/Policy";
import { useSession } from "../state/Session";

const PolicyDialogContainer = () => {
   const { result: policy } = usePolicy();
   const { acceptPolicy } = useSession();

   return <FMPolicyDialog content={policy} onAccepted={acceptPolicy} />;
};

export const AgreementPage = () => <PolicyDialogContainer />;
